export const AncillariesActionTypes = {
  SET_ANCILLARY_ART: 'SET_ANCILLARY_ART',
  CLEAR_ANCILLARY_ART: 'CLEAR_ANCILLARY_ART',
};
